'use strict';

var jsxRuntime = require('react/jsx-runtime');

const Design = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-design--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M29.9951 23L22 37L25 46L29.9951 46L35 46L38 37L29.9951 23Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M35 46H25C24.4477 46 24 46.4477 24 47V51C24 51.5523 24.4477 52 25 52H35C35.5523 52 36 51.5523 36 51V47C36 46.4477 35.5523 46 35 46Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M30 23L30 37",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M28 37H32",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M10 27C12.356 18.3627 20.4173 12 30 12C39.5827 12 47.644 18.3627 50 26.99",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M13 27H7C6.44772 27 6 27.4477 6 28V34C6 34.5523 6.44772 35 7 35H13C13.5523 35 14 34.5523 14 34V28C14 27.4477 13.5523 27 13 27Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M53 27H47C46.4477 27 46 27.4477 46 28V34C46 34.5523 46.4477 35 47 35H53C53.5523 35 54 34.5523 54 34V28C54 27.4477 53.5523 27 53 27Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M33 8H27C26.4477 8 26 8.44772 26 9V15C26 15.5523 26.4477 16 27 16H33C33.5523 16 34 15.5523 34 15V9C34 8.44772 33.5523 8 33 8Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M26 12L10 12",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M10 15C11.6569 15 13 13.6569 13 12C13 10.3431 11.6569 9 10 9C8.34314 9 7 10.3431 7 12C7 13.6569 8.34314 15 10 15Z",
                    fill: "#9E9E9E"
                }),
                jsxRuntime.jsx("path", {
                    d: "M34 12H50",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M50 15C51.6569 15 53 13.6569 53 12C53 10.3431 51.6569 9 50 9C48.3431 9 47 10.3431 47 12C47 13.6569 48.3431 15 50 15Z",
                    fill: "#9E9E9E"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-design",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M29.9951 23L22 37L25 46L29.9951 46L35 46L38 37L29.9951 23Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M35 46H25C24.4477 46 24 46.4477 24 47V51C24 51.5523 24.4477 52 25 52H35C35.5523 52 36 51.5523 36 51V47C36 46.4477 35.5523 46 35 46Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M30 23L30 37",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M28 37H32",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 27C12.356 18.3627 20.4173 12 30 12C39.5827 12 47.644 18.3627 50 26.99",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 27H7C6.44772 27 6 27.4477 6 28V34C6 34.5523 6.44772 35 7 35H13C13.5523 35 14 34.5523 14 34V28C14 27.4477 13.5523 27 13 27Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M53 27H47C46.4477 27 46 27.4477 46 28V34C46 34.5523 46.4477 35 47 35H53C53.5523 35 54 34.5523 54 34V28C54 27.4477 53.5523 27 53 27Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M33 8H27C26.4477 8 26 8.44772 26 9V15C26 15.5523 26.4477 16 27 16H33C33.5523 16 34 15.5523 34 15V9C34 8.44772 33.5523 8 33 8Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M26 12L10 12",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 15C11.6569 15 13 13.6569 13 12C13 10.3431 11.6569 9 10 9C8.34314 9 7 10.3431 7 12C7 13.6569 8.34314 15 10 15Z",
                fill: "#212121"
            }),
            jsxRuntime.jsx("path", {
                d: "M34 12H50",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M50 15C51.6569 15 53 13.6569 53 12C53 10.3431 51.6569 9 50 9C48.3431 9 47 10.3431 47 12C47 13.6569 48.3431 15 50 15Z",
                fill: "#212121"
            })
        ]
    });
};

module.exports = Design;
